// extracted by mini-css-extract-plugin
export default {"table":"Table_table__oFFJG","th":"Table_th__9IXvZ","td":"Table_td__vsuAX","overflowhide":"Table_overflowhide__S14wE"};